import { AppDispatch, RootState } from 'src/store/store';
import { connect } from 'react-redux';
import { cleanADirtyTote } from 'src/store/common-slices/cleanADirtyToteSlice';
import { CleanADirtyToteInput } from 'src/models/cleanADirtyTote';
import CleanContainerConfirmModal from './CleanContainerConfirmModal';

const mapStateToProps = (state: RootState) => ({
    uiAlertState: state.UI.alertState,
    warehouseId: state.Init.initData.gradingNodeDetails.id,
    associate: state.Init.initData.associateDetails.id,
    locale: state.Init.initData.associateDetails.locales[0]
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    cleanADirtyTote: (input: CleanADirtyToteInput) => dispatch(cleanADirtyTote(input)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CleanContainerConfirmModal);
